import React from "react";
import Lottie from "lottie-react";
import Animation_success from "./animation_success.json";
import {Autocomplete, Box, Grid, TextField} from '@mui/material';
import { display, styled } from '@mui/system';
import EastIcon from '@mui/icons-material/East';
import '../servicesOperation.css'
export const Modal_Filtro_Structure = ({key, labelTitle, label_input_one, id_one, label_input_two, id_two}) => {
  
    const Label = styled('label')({
        display: 'block',
        fontWeight: 'bold',
        paddingLeft: '18px'
      });
    return <>
    
                <Grid item  xs={6} sm={6} md={6}  key={key}>
                    <Label>{labelTitle}</Label>
                        <div className="filter_input_container">
                            <TextField sx={{ margin: '16px'}} id={id_one} label={label_input_one} />
                            <EastIcon sx={{width: '16px'}} />
                            <TextField sx={{ margin: '16px'}} id={id_two} label={label_input_two} />
                        </div>

                </Grid>

        </>
};

export default Modal_Filtro_Structure;